module.exports = __webpack_public_path__ + "static/media/130.8cf0efe8.png";